import classNames from 'classnames/bind';
import { TripType, SearchType } from 'contexts/searchParams';
import { ITripDesc } from 'hooks/useHistory';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  isDirect: boolean;
  tripList: ITripDesc[];
  tripType: string;
  searchType: string;
}

class Route {
  code: string;

  name: string;

  constructor(code: string, name: string) {
    this.code = code;
    this.name = name;
  }
}

export const getTripDisplay = (tripList: ITripDesc[], tripType: string) => {
  if (tripList === undefined || tripList === null || tripList.length === 0)
    return [];

  const firstTrip = tripList[0];

  if (tripType !== TripType[TripType.MD])
    return [
      new Route(firstTrip.departureCityCode, firstTrip.departureCityName),
      new Route(firstTrip.destinationCityCode, firstTrip.destinationCityName),
    ];

  let prevTrip: Route | undefined;

  return tripList.flatMap(trip => {
    const destRoute = new Route(
      trip.destinationCityCode,
      trip.destinationCityName,
    );

    const routes =
      prevTrip && prevTrip.code === trip.departureCityCode
        ? [destRoute]
        : [
            new Route(trip.departureCityCode, trip.departureCityName),
            destRoute,
          ];

    prevTrip = destRoute;

    return routes;
  });
};

function Routes(props: IProps) {
  const { isDirect, tripList, tripType, searchType } = props;

  const routes = getTripDisplay(tripList, tripType);

  return (
    <div className={cx('Routes')}>
      {routes.map(({ code, name }, idx) => (
        <span
          className={cx(`${idx > 0 ? 'end' : 'start'}`)}
          key={`${idx}_${code}`}
        >
          <b className={cx('name')}>{name}</b>
          <i className={cx('code')}>{code}</i>
        </span>
      ))}
      {searchType === SearchType.INTERNATIONAL && isDirect && (
        <i className={cx('badge')}>직항</i>
      )}
    </div>
  );
}

export default Routes;
